// src/components/profile/ProfileSidebar.tsx

import React from 'react';
import type { IconProps } from 'react-bootstrap-icons'; 
import { SidebarArea } from '../../styles/profile/layout.style';
import { SelectButton } from '../../styles/profile/profile.style';

export interface TabConfig {
  label: string; 
  Icon: React.ComponentType<IconProps>;
}

// Define the props our new component will accept
interface ProfileSidebarProps {
  activeTab: string;
  onTabChange: (tab: string) => void;
  tabs: readonly TabConfig[];
}

export const ProfileSidebar: React.FC<ProfileSidebarProps> = ({
  activeTab,
  onTabChange,
  tabs
}) => {
  return (
    <SidebarArea>
      {tabs.map((tab) => (
        <SelectButton
          key={tab.label}
          // The button is active if it matches the prop from the parent
          active={activeTab === tab.label}
          css={{ width: '100%', 
                 marginTop: tab.label === 'Settings' ? 'auto' : '0',
          }}
          // When clicked, it calls the function passed down from the parent
          onClick={() => onTabChange(tab.label)}
        >
          <tab.Icon size={20} />
          <span>{tab.label}</span>
     </SelectButton>
      ))}
    </SidebarArea>
  );
};